/**
 * Shared client-side navigation. Kept as a single source of truth so
 * ClientDashboard.jsx and ClientBilling.jsx (and any future /client/*
 * page) can't drift out of sync.
 */
import { LayoutDashboard, FilePlus, FileText, Briefcase, CreditCard, ShieldCheck } from "lucide-react";

export const CLIENT_NAV = [
    { to: "/client",                    label: "Tableau de bord",   icon: LayoutDashboard, end: true },
    { to: "/client/moyen-de-paiement",  label: "Moyen de paiement", icon: ShieldCheck },
    { to: "/devis",                     label: "Nouvelle mission",  icon: FilePlus },
    { to: "/client/devis",              label: "Mes devis",         icon: FileText },
    { to: "/client/missions",           label: "Mes missions",      icon: Briefcase },
    { to: "/client/facturation",        label: "Facturation J+10",  icon: CreditCard },
];
